import { useEffect, useMemo } from "react";
import type { FieldPath } from "react-hook-form";

import type { LPQuoteInput } from "../../types/Rater.types";
import {
  ReplacementCostPercentage,
  getAllowedReplacementCostPercentages,
  getReplacementCostPercentageOptions,
} from "../rules";
import type { BusinessRulesArgs } from "./useBusinessRules";

export function useReplacementCostPercentageRules({ locationValues, tabItem, setValue, enabled }: BusinessRulesArgs) {
  const { RCpercentage, valuation } = locationValues;

  const allowedReplacementCostPercentages = useMemo(
    () => getAllowedReplacementCostPercentages(valuation, enabled),
    [enabled, valuation]
  );
  const replacementCostPercentageOptions = useMemo(
    () => getReplacementCostPercentageOptions(valuation, enabled),
    [enabled, valuation]
  );

  useEffect(() => {
    if (allowedReplacementCostPercentages.length === 0) return;

    const currentPercentage = Number(RCpercentage) as ReplacementCostPercentage;
    if (allowedReplacementCostPercentages.includes(currentPercentage)) return;

    const fallbackPercentage = allowedReplacementCostPercentages[0];
    const replacementCostPercentagePath = `locations.${tabItem}.RCpercentage` as FieldPath<LPQuoteInput>;

    setValue(replacementCostPercentagePath, String(fallbackPercentage), {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
  }, [RCpercentage, allowedReplacementCostPercentages, setValue, tabItem]);

  return { allowedReplacementCostPercentages, replacementCostPercentageOptions };
}
